import { UserWealth } from "@foxone/api/src/models/defi";
import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";

const state = () => ({
  wealthes: {},
  loading: false
});

export type AccountState = ReturnType<
  () => {
    wealthes: UserWealth;
    loading: boolean;
  }
>;

const getters: GetterTree<AccountState, {}> = {};

const mutations: MutationTree<AccountState> = {
  SET_WEALTHES(state, wealthes) {
    state.wealthes = wealthes;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  }
};

const actions: ActionTree<AccountState, {}> = {
  async loadWealthes({ commit }) {
    // commit("SET_LOADING", true);
    // const wealthes = await this.$api.defi.getWealthes();
    // commit("SET_WEALTHES", wealthes);
    // commit("SET_LOADING", true);
  },
  removeWealthes({ commit }) {
    commit("SET_WEALTHES", {});
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
